<template>
  <div class="admin-source-page source-page-form">
    <div class="page-content">
      <bean-form :columns="columns()" v-model="form" @submit="handleSubmit">
      </bean-form>
      <div v-if="runtime">执行时间: {{ runtime }}s</div>
      <el-image
        style="width: 100px; height: 100px; margin-right: 20px;"
        v-for="item in images"
        :key="item"
        :src="item"
        :initial-index="0"
        :preview-src-list="images"
      >
      </el-image>
    </div>
  </div>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";

@Component
export default class Threevjia extends Vue {
  form = {};
  images = [];
  runtime = null;

  columns() {
    return [
      {
        prop: "initImage",
        label: "图片",
        renderCell: {
          component: "upload",
          required: true,
          props: {
            limit: 1
          }
        }
      },
      {
        prop: "prompt",
        label: "提示",
        renderCell: {
          component: "input",
          required: true,
          hint: "描述, 根据描述生成对应的图片"
        }
      },
      {
        prop: "negativePrompt",
        label: "反向提示",
        renderCell: {
          component: "input",
          hint: "负向描述, 生成图片不想要出现的东西，比如：logo,text"
        }
      },
      {
        prop: "batchCount",
        label: "生成张数",
        renderCell: {
          component: "inputNumber",
          hint:
            "生成张数, 最后出图的张数，取值0-16，传入0值或不传时采用默认值 1",
          props: {
            step: 1,
            min: 0,
            max: 16
          }
        }
      },
      {
        prop: "guidanceScale",
        label: "引导强度",
        renderCell: {
          component: "inputNumber",
          hint:
            "引导强度, 生成的图像与输入提示的紧密程度与输入的多样性之间的权衡度，取值0-30，传入0值或不传时采用默认值13",
          props: {
            step: 1,
            min: 0,
            max: 30
          }
        }
      },
      {
        prop: "steps",
        label: "迭代次数",
        renderCell: {
          component: "inputNumber",
          hint:
            "迭代次数, 采样迭代步数，控制去噪步骤的数量,取值0-100，传入0值或不传时采用默认值24",
          props: {
            step: 1,
            min: 0,
            max: 100
          }
        }
      },
      {
        prop: "width",
        label: "宽度",
        renderCell: {
          component: "inputNumber",
          hint:
            "宽, 生成图片分辨率的宽度，取值64-2048 传入0值或不传时采用默认值 896",
          props: {
            step: 1,
            min: 64,
            max: 2048
          }
        }
      },
      {
        prop: "height",
        label: "高度",
        renderCell: {
          component: "inputNumber",
          hint:
            "高, 生成图片分辨率的高度，取值64-2048 传入0值或不传时采用默认值704",
          props: {
            step: 1,
            min: 64,
            max: 2048
          }
        }
      }
    ];
  }

  async handleSubmit() {
    this.runtime = null;
    this.images = [];
    const resp = await this.$autoLoading(
      this.$request.post("/active_storage/threevjia/i2i", this.form, {
        return_res: true
      })
    );
    this.runtime = resp.headers["x-runtime"];
    this.images = resp.data;
  }
}
</script>
